<template>
  <div class="sensitive" v-loading="loading">
    <div class="sensitive-first">
      <div
        class="sensitive-first-block"
        v-for="(item, index) in 2"
        :key="index"
      >
        <div class="sensitive-first-block-title">
          {{ index == 0 ? '敏感词搜索' : '编辑id名称' }}
        </div>
        <div class="sensitive-first-block-input">
          <el-input
            v-if="index == 0"
            v-model="sensitiveSearch"
            clearable
            placeholder="请输入敏感词"
          ></el-input>

          <el-input
            v-if="index == 1"
            v-model="compileId"
            clearable
            placeholder="请输入id名称"
          ></el-input>
        </div>
      </div>

      <div class="sensitive-first-inquire" @click="resetInquire">查询</div>
      <div class="sensitive-first-reset" @click="resetClick">重置</div>
    </div>

    <div class="sensitive-second">
      <div class="sensitive-second-top">
        <div class="second-top-left">查询结果</div>
        <div class="second-top-right">
          <div class="second-top-right-derive" @click="addition">
            <img class="derive-img" src="../../assets/common/common-add.png" />
            <div class="derive-title">添加</div>
          </div>
        </div>
      </div>

      <div class="sensitive-second-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          border=""
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column prop="name" label="敏感词"> </el-table-column>
          <el-table-column prop="admin_name" label="最后编辑id名称">
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div class="table-display">
                <div class="table-operation" @click="compileBtn(scope.row)">
                  编辑
                </div>

                <div class="table-operation" @click="deteleBtn(scope.row)">
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="sensitive-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        style="margin-top: 10vh"
        @close="additionReset"
        :style="{
          '--height': additionError == false ? '1.09375rem' : '1.25rem',
        }"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="addition-div-top-title">
                {{ additionId == '' ? '添加' : '编辑' }}
              </div>
              <img
                class="addition-div-top-img"
                src="../../assets/common/close.png"
                @click="additionReset"
              />
            </div>

            <div class="addition-div-hinh" v-if="additionError == true">
              <div class="addition-div-hinh-title">
                {{
                  additionSensitive == ''
                    ? '抱歉，敏感词添加不能为空!'
                    : '抱歉，敏感词不可超10个字!'
                }}
              </div>
            </div>

            <div class="addition-div-center">
              <div class="addition-div-center-title">商品名称</div>
              <div class="addition-div-center-input">
                <el-input
                  placeholder="敏感词不可超10个字"
                  v-model="additionSensitive"
                  clearable
                >
                </el-input>
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="button-reset" @click="additionReset">重置</div> -->
              <div class="button-confirm" @click="additionConfirm">确定</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="cancelDetele"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">是否删除该敏感词信息？</div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getsensitive,
  postsensitiveAdd,
  deletefnsensitive,
} from '../../api/common'
export default {
  data() {
    return {
      // 敏感词搜索
      sensitiveSearch: '',
      // 编辑id
      compileId: '',
      // 页数
      page: 1,
      // 页码
      limit: 10,

      // 表格区域
      tableData: [],
      // 获取表格总数
      totalNum: 0,

      // 添加弹出框 开启
      additionDialogVisible: false,
      // 添加敏感词
      additionSensitive: '',
      // 添加或者编辑id
      additionId: '',
      // 添加或者编辑失败
      additionError: false,
      // 删除弹出框
      deteleDialogVisible: false,
      // 刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      basicFunShow: false,
    }
  },
  created() {
    // 获取敏感词列表
    this.loading = true
    this.getsensitiveClick()

    setTimeout(() => {
        this.basicFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取敏感词
    getsensitiveClick() {
      let params = {
        name: this.sensitiveSearch, // 敏感词搜索
        admin_name: this.compileId, // 编辑id
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getsensitive(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.mgcList
          // 获取表格总数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },
    //查询
    resetInquire() {
      this.loading = true
      this.getsensitiveClick()
    },

    // 点击重置
    resetClick() {
      this.sensitiveSearch = ''
      this.compileId = ''
      this.loading = true
      this.getsensitiveClick()
    },

    // 添加  开启弹出框
    addition() {
      if (this.basicFunShow == false) {
        return
      }
      this.additionError = false
      this.additionDialogVisible = true
    },
    // 添加弹出框  确定
    additionConfirm() {
      if (this.additionSensitive != '' && this.additionSensitive.length <= 10) {
        let params = {
          id: this.additionId,
          name: this.additionSensitive,
        }

        postsensitiveAdd(params).then((res) => {
          if (res.resultStatus == true) {
            this.loading = true
            this.$message({
              message: this.additionId == '' ? '添加成功！' : '修改成功！',
              type: 'success',
            })
            this.additionError = false
            this.getsensitiveClick()
            this.additionDialogVisible = false
          }
        })
      } else {
        this.additionError = true
      }
    },
    // 添加弹出框  重置
    additionReset() {
      this.additionId = ''
      this.additionError = false
      this.additionSensitive = ''
      this.additionDialogVisible = false
    },

    // 编辑
    compileBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      this.additionSensitive = item.name
      this.additionId = item.id
      this.additionDialogVisible = true
    },

    // 删除
    deteleBtn(item) {
      if (this.basicFunShow == false) {
        return
      }
      this.additionId = item.id
      this.deteleDialogVisible = true
    },
    // 删除弹出框 确定
    confirmDetele() {
      let params = this.additionId

      deletefnsensitive(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '删除成功！',
            type: 'success',
          })

          this.loading = true
          this.deteleDialogVisible = false
          this.getsensitiveClick()
        }
      })
    },
    // 删除弹出框 取消
    cancelDetele() {
      this.additionId = ''
      this.deteleDialogVisible = false
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.getsensitiveClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.getsensitiveClick()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

/deep/ .el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
  border-color: #dcdfe6;
}

.sensitive {
  .sensitive-first {
    height: 96px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;

    .sensitive-first-block {
      margin-right: 25px;
      .sensitive-first-block-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .sensitive-first-block-input {
        margin-top: 4px;
        /deep/ .el-input {
          width: 180px;
          height: 32px;
        }

        /deep/ .el-input__inner {
          padding: 0 10px;
          box-sizing: border-box;
          height: 32px;
          background-color: rgba(255, 255, 255, 0);
        }

        /deep/ .el-input__inner::-webkit-input-placeholder {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #cacaca;
          line-height: 32px;
        }
      }
    }

    .sensitive-first-inquire,
    .sensitive-first-reset {
      width: 110px;
      height: 36px;
      background: #222222;
      border-radius: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      line-height: 36px;
      margin-top: 17px;
    }

    .sensitive-first-reset {
      background: #f4f5f9;
      margin-left: 10px;
      color: #999999;
    }
  }

  .sensitive-second {
    margin-top: 24px;
    background: #ffffff;
    min-height: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .sensitive-second-top {
      width: 100%;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .second-top-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }

      .second-top-right {
        display: flex;

        .second-top-right-derive {
          display: flex;
          height: 36px;
          align-items: center;
          justify-content: center;
          width: 82px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          margin-left: 10px;
          cursor: pointer;

          .derive-img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }

          .derive-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }

    .sensitive-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-display {
        display: flex;
        .table-operation {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }

        .table-operation:nth-child(2) {
          margin-left: 24px;
        }
      }
    }

    .sensitive-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  /* 添加弹出框 */
  .addition {
    /deep/ .el-dialog {
      width: 444px;
      height: var(--height) !important;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .addition-div {
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px
          rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 10px;

      .addition-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .addition-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .addition-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .addition-div-hinh {
        display: flex;
        height: 30px;
        align-items: center;
        padding: 0 24px;
        box-sizing: border-box;
        background: rgba(249, 182, 60, 0.1);
        .addition-div-hinh-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ed6d1f;
        }
      }

      .addition-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 20px;
        .addition-div-center-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .addition-div-center-input {
          margin-top: 4px;
          width: 100%;
          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }
      }

      .addition-div-button {
        margin-top: 24px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 16px;
        box-sizing: border-box;
        border-top: 1px solid #d9d9d9;

        .button-reset,
        .button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  // 删除
  .detele {
    /deep/ .el-dialog {
      height: 230px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .detele-div {
      width: 100%;
      text-align: center;
      .detele-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .detele-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 8px;
      }

      .detele-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 40px;

        .detele-div-button-left,
        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .detele-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
